import React from 'react'
import { styled, Tooltip } from '@mui/material'
import ExclusiveToggleGroup from '../../components/editors/toggle/ExclusiveToggleGroup'
import { intl } from '../../../i18n'
import {
  AggregateTarget,
  WbsItemType,
} from '../../../domain/entity/WbsItemEntity'
import deliverableSvg from '../../../assets/deliverable.svg'
import taskSvg from '../../../assets/task.svg'

export const AggregateTargetToggleGroup = (props: {
  value: AggregateTarget
  onChange: (value: AggregateTarget) => void
  height?: number
  disabled?: boolean
  disabledReason?: string
  /** 成果物の代わりに出す選択肢。チケット別進捗状況ではチケットを成果物の欄で数えるため「チケット」と出す */
  deliverableOption?: { label: string; iconUrl?: string }
}) => {
  const { disabled, disabledReason, deliverableOption } = props
  const toggleGroup = (
    <ExclusiveToggleGroup
      value={props.value}
      options={[
        {
          label:
            deliverableOption?.label ??
            intl.formatMessage({ id: 'wbsItemType.deliverable' }),
          value: WbsItemType.DELIVERABLE,
          iconUrl: deliverableOption
            ? deliverableOption.iconUrl
            : deliverableSvg,
        },
        {
          label: intl.formatMessage({
            id: 'wbsItemType.task',
          }),
          value: WbsItemType.TASK,
          iconUrl: taskSvg,
        },
      ]}
      onChange={
        disabled
          ? () => undefined
          : value =>
              props.onChange(
                value as WbsItemType.DELIVERABLE | WbsItemType.TASK
              )
      }
      height={props.height}
    />
  )
  if (!disabled) return toggleGroup
  // ExclusiveToggleGroup に disabled を渡すと選択中の項目まで塗りが消えて
  // どちらで集計しているか読み取れなくなるため、外側で操作だけを止める
  return (
    <Tooltip title={disabledReason ?? ''} placement="top" arrow={true}>
      <LockedArea aria-disabled={true}>
        <LockedContent>{toggleGroup}</LockedContent>
      </LockedArea>
    </Tooltip>
  )
}

const LockedArea = styled('span')({
  display: 'inline-flex',
  cursor: 'not-allowed',
})

const LockedContent = styled('span')({
  display: 'inline-flex',
  pointerEvents: 'none',
  opacity: 0.6,
})
